<template>
  <UsersForm label="Add User" :on-success="onSuccess" />
</template>

<script>
import UsersForm from '@/components/admin/users/users-form';

export default {
  name: 'AdminNewUser',
  components: { UsersForm },
  methods: {
    onSuccess() {
      this.$router.push({ name: 'adminUsersList' });
      this.$store.dispatch('users/setFlashMessage', {
        message: 'User has been added successfully.'
      });
    }
  }
};
</script>
